import Home from "../../../components/Home/Home";
import {sidebarItems} from "../../../utils/sidebarItems";

const TechnicianHome = () => {
    return (
        <Home navigationItems={sidebarItems.technician}/>
    )
}

export default TechnicianHome;